export default {"src":"/_next/static/media/Beijing.d39ee69e.svg","height":69,"width":56};